import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'

const swiperOptions = {
  init: false,
  keyboard: true,
  speed: 1000,
  spaceBetween: 10,
  slidesPerView: 'auto',
  centeredSlides: true,
  parallax: true,
  preloadImages: false,
  watchSlidesVisibility: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 3
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction'
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
}

export default {
  components: {
    Swiper
  },
  data: () => ({
    swiperRef: undefined
  }),
  directives: {
    'swiper-products': {
      inserted (el, binding, vnode) {
        const swiperRef = new Swiper(el, swiperOptions)
        vnode.context.$data.swiper = swiperRef
        /* On init
        vnode.context.swiper.on('init', () => { })
        */
        vnode.context.$data.swiper.init()
        vnode.context.$data.swiper.update()
      },
      componentUpdated (el, binding, vnode) {
        vnode.context.$data.swiper.init()
        vnode.context.$data.swiper.update()
      },
      unbind (el, binding, vnode) {
        vnode.context.$data.swiper.destroy()
      }
    }
  }
}
